/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './gallery.defs'
export { main as default } from './gallery.defs'
